import React from 'react';

import { Wrap } from '@components';
import { Outlet } from 'react-router-dom';

const AppDownloadPage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default AppDownloadPage;
